import React from 'react';
import H5 from './InfiniteScrollList/h5';
import PC from './InfiniteScrollList/pc';
import type { InfiniteScrollListProps as BaseProps } from './InfiniteScrollList/Base';

export interface InfiniteScrollListProps extends BaseProps {
    variant?: 'pc' | 'h5';
}

const InfiniteScrollList: React.FC<InfiniteScrollListProps> = ({ variant = 'pc', ...rest }) => {
    if (variant === 'h5') return <H5 {...rest} />;
    return <PC {...rest} />;
};

export default InfiniteScrollList;
